import {getEnvConfig} from '@web-catalog/env';
import Script from 'next/script';
import {Dispatch, SetStateAction, useEffect} from 'react';

import {useOmicronABFlag} from '@web-catalog/hooks';

import {
  authDoneStates,
  useAuthorizedProfile,
  useAuthProgressState,
} from '@web-catalog/store/auth';
import {useOmicronABAtomValue} from '@web-catalog/store/omicronAB';

import {emitYmEvent, logTmrEvent} from '@web-catalog/utils/analytics/logEvent';

export const ExternalSSP = ({
  slotId,
  setIsSSPShown,
}: {
  slotId: string;
  setIsSSPShown: Dispatch<SetStateAction<boolean>>;
}) => {
  const userInfo = useAuthorizedProfile();
  const sspAdsAuthEnabled = useOmicronABFlag('WEB_SSP_AD_WITH_AUTH');

  const authProgressState = useAuthProgressState();
  const isAuthFinished = authDoneStates.includes(authProgressState);

  const omicronResponse = useOmicronABAtomValue();

  useEffect(() => {
    if (sspAdsAuthEnabled && isAuthFinished && !userInfo?.id) {
      setIsSSPShown(false);
    }
  }, [isAuthFinished, setIsSSPShown, sspAdsAuthEnabled, userInfo?.id]);

  if (sspAdsAuthEnabled) {
    if (!userInfo?.id) {
      return;
    }
  } else {
    if (!isAuthFinished) {
      return;
    }
  }

  const onLoad = () => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.ssp.initSSP({
      userInfo,
      onClose: () => {
        setIsSSPShown(false);
      },
      logTmrEvent,
      emitYmEvent,
      slotId,
      omicron: omicronResponse?.config,
    });
  };

  return (
    <Script
      id="ssp-ads"
      src={getEnvConfig().SSP_SCRIPT_URL}
      async
      onLoad={onLoad}
    />
  );
};
